import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);

interface CardCarouselSwiperProps {
    el: HTMLElement;
}

const CardCarousel = ({ el }: CardCarouselSwiperProps): void => {
    const swiperContainer: HTMLElement | null = el.querySelector('.swiper');
    const prevEl: HTMLElement | null = el.querySelector('.card-carousel-prev');
    const nextEl: HTMLElement | null = el.querySelector('.card-carousel-next');


    if (!swiperContainer) {
        return;
    }

    const swiperBreakpoints = {
        640: { spaceBetween: 24 },
        1024: { spaceBetween: 32 },
    };


    const cardCarouselSwiper = new Swiper(swiperContainer, {
        init: false,
        spaceBetween: 16,
        slidesPerView: 'auto',
        breakpoints: swiperBreakpoints,
        watchOverflow: true,
        watchSlidesProgress: true,
        // wrapperClass: 'card-carousel-swiper',
        navigation: {
            nextEl,
            prevEl,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });

    cardCarouselSwiper.init();
};

export default CardCarousel;
